
<img *ngIf="avatarImageId != null" src="{{'/library/' + avatarImageId | evePortalCoreUrl}}" class="eve-avatar-image">
<img *ngIf="avatarImageId == null" src="{{ '/assets/images/DefaultHuntGroup.png' | evePortalCoreUrl}}" class="eve-avatar-image">

<button mat-icon-button type="button" class="eve-avatar-edit" (click)="showModal()">
  <i class="fa fa-pencil"></i>
</button>
